import { render, staticRenderFns } from "./CompanySearch.vue?vue&type=template&id=114aa090&scoped=true"
import script from "./CompanySearch.vue?vue&type=script&lang=js"
export * from "./CompanySearch.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=114aa090&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "114aa090",
  null
  
)

export default component.exports